// DEV-Umgebung.
import { BackendEnvironment, CdnEnvironment, DesktopEnvironment, Environment, MobileEnvironment, WebsiteEnvironment } from './environment.model';

export const environment: Environment = {
    name: 'dev',
    production: false,
    logLevel: 'debug',
    branding: {
        logo: '/pridehub/envs/dev/logo.svg',
        appIcon: '/pridehub/envs/dev/app-icon.svg',
        appleTouchIcon: '/pridehub/envs/dev/icon-192.png',
    },
};

export const backendEnvironment: BackendEnvironment = {
    serverUrl: 'https://dev.api.bochum-rebels.de',
    apiUrl: 'https://dev.api.bochum-rebels.de/api/v1',
    websocketUrl: 'wss://dev.api.bochum-rebels.de/api/v1/',
    mediaUrl: 'https://dev.api.bochum-rebels.de/api/v1/public/media/',
    fusionAuth: {
        url: 'https://dev.fusionauth.bochum-rebels.de',
        clientId: 'dd3f03c9-68c9-47b3-9024-2429a6423f07',
    },
};

export const desktopEnvironment: DesktopEnvironment = {
    url: 'https://dev.pridehub.bochum-rebels.de',
    manifest: '/pridehub/envs/dev/manifest.webmanifest',
    analytics: {
        enabled: false,
        url: 'https://analytics.bochum-rebels.de/',
        siteId: '',
    },
    enableRoleSimulator: false,
    serviceWorkerEnabled: true,
    mockAuth: false,
};

export const mobileEnvironment: MobileEnvironment = {
    url: 'https://dev.mobile.pridehub.bochum-rebels.de',
    manifest: '/pridehub/envs/dev/manifest.webmanifest',
    serviceWorkerEnabled: true,
    mockAuth: false,
};

export const websiteEnvironment: WebsiteEnvironment = {
    externalApiBaseUrl: '/api/external',
    mediaUrl: '/api/external/media/',
    countdownShowTime: 10,
    hCaptchaSiteKey: '8d3c9d4a-b0fc-4380-b6ba-d0f611fc9ce4',
};

export const cdnEnvironment: CdnEnvironment = {
    assetBaseUrl: '',
};
